/// <reference types="vite-plugin-svgr/client" />
import type { ElementWithIconConfigType } from '@/types/elementWithIcon.types'

import { AccountsRoutePathsEnum } from '@/modules/accounts/routes/accountsRouteConfig.types'
import { ActionPlanRoutePathsEnum } from '@/modules/actionPlan/routes/actionPlanRouteConfig.types'
import { AdminRoutePathsEnum } from '@/modules/admin/routes/adminRouteConfig.types'
import { AdvisorUsersRoutePathsEnum } from '@/modules/advisors/users/routes/advisorsUsersRouteConfig.types'
import { AdvisorsListRoutePathsEnum } from '@/modules/advisorsPage/routes/advisorsListRouteConfig.types'
import { BudgetRoutePathsEnum } from '@/modules/budget/routes/budgetRouteConfig.types'
import { DashboardRoutePathsEnum } from '@/modules/dashboard/routes/dashboardRouteConfig.types'
import { EmployerRoutePathsEnum } from '@/modules/employer/routes/employerRouteConfig.types'
import { EmployerAdvisorsRoutePathsEnum } from '@/modules/employerAdvisors/routes/employerAdvisorsRouteConfig.types'
import { EmployerUsersRoutePathsEnum } from '@/modules/employerUsers/routes/employerUsersRouteConfig.types'
import { NetWorthRoutePathsEnum } from '@/modules/netWorth/routes/netWorthRouteConfig.types'

import { role } from '@/__generated__/requests'

import ActionPlanIcon from '@/assets/icons/actionPlan.svg?react'
import AdvisorsIcon from '@/assets/icons/advisors.svg?react'
import UsersIcon from '@/assets/icons/advisorUsers.svg?react'
import BudgetIcon from '@/assets/icons/budget.svg?react'
import DashboardIcon from '@/assets/icons/dashboard.svg?react'
import NetWorthIcon from '@/assets/icons/moneyBag.svg?react'
import MyAccountsIcon from '@/assets/icons/myAccounts.svg?react'
import PlaneIcon from '@/assets/icons/plane.svg?react'

export const NAVIGATION_BAR_CONFIG: ElementWithIconConfigType[] = [
  {
    icon: DashboardIcon,
    label: 'Dashboard',
    role: role.EMPLOYEE,
    to: DashboardRoutePathsEnum.DASHBOARD,
  },
  {
    icon: NetWorthIcon,
    label: 'Net Worth',
    role: role.EMPLOYEE,
    to: NetWorthRoutePathsEnum.NET_WORTH,
  },
  {
    icon: BudgetIcon,
    label: 'Budget',
    role: role.EMPLOYEE,
    to: BudgetRoutePathsEnum.BUDGET,
  },
  {
    icon: MyAccountsIcon,
    label: 'My Accounts',
    role: role.EMPLOYEE,
    to: AccountsRoutePathsEnum.ACCOUNTS,
  },
  {
    icon: AdvisorsIcon,
    label: 'Planners',
    role: role.EMPLOYEE,
    to: AdvisorsListRoutePathsEnum.ADVISORS_LIST,
  },
  {
    icon: ActionPlanIcon,
    label: 'Action Plan',
    role: role.EMPLOYEE,
    to: ActionPlanRoutePathsEnum.ACTION_PLAN,
  },
  {
    icon: UsersIcon,
    label: 'Users',
    role: role.ADVISOR,
    to: AdvisorUsersRoutePathsEnum.USERS,
  },
  {
    icon: PlaneIcon,
    label: 'Messages',
    role: role.ADVISOR,
    to: AdvisorUsersRoutePathsEnum.CHAT,
  },
  {
    icon: DashboardIcon,
    label: 'Dashboard',
    role: role.EMPLOYER,
    to: EmployerRoutePathsEnum.DASHBOARD,
  },
  {
    icon: UsersIcon,
    label: 'Users',
    role: role.EMPLOYER,
    to: EmployerUsersRoutePathsEnum.USERS,
  },
  {
    icon: AdvisorsIcon,
    label: 'Planners',
    role: role.EMPLOYER,
    to: EmployerAdvisorsRoutePathsEnum.ADVISORS,
  },
  {
    icon: DashboardIcon,
    label: 'Dashboard',
    role: role.ADMIN,
    to: AdminRoutePathsEnum.DASHBOARD,
  },
]
